import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Toolbar,
  Grid,
  Typography,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  MenuItem,
  TextField,
  Chip,
  Checkbox,
  ListItemText,
  CircularProgress,
  Snackbar,
  Slide,
  InputAdornment,
  FormControlLabel,
  Switch as MUSwitch,
  Slider,
  Icon,
  withStyles,
} from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import { CalendarToday, Clear } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import MaterialTable from "material-table";
import {
  DatePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { DropzoneArea } from "material-ui-dropzone";
import useStyles from "../hooks/useStyles";
import useTableIcons from "../hooks/useTableIcons";
import { useDefaultTableStyling as stylingOptions } from "../dataColumns/globalStyle";
import Switch from "../utils/Switch";

// Slider con barra (rail/track) y thumb más gruesos, para controles tipo prioridad.
const ThickSlider = withStyles({
  root: { height: 10, padding: "18px 0" },
  rail: { height: 10, borderRadius: 5, opacity: 0.35 },
  track: { height: 10, borderRadius: 5 },
  thumb: { height: 22, width: 22, marginTop: -6, marginLeft: -11 },
  mark: { height: 10, width: 2 },
  markActive: { height: 10 },
})(Slider);

const ModalDialog = ({
  open,
  handleClose,
  modalHeader,
  modalContent,
  modalActions,
  modalFormResetKeys,
  modalTaskRunning,
  modalFormError,
}) => {
  const [snak_open, setSnackOpen] = useState(false);
  const { isForm, title, header, modalWidth, isReadOnly } = modalHeader;
  const {
    handleSubmit,
    control,
    formState: { errors },
    clearErrors,
    reset,
    getValues,
  } = useForm();
  const classes = useStyles();
  const { tableIcons } = useTableIcons();
  const clearData = (keepDefaultValues = false) => {
    if (modalContent) {
      const formObj = Object.assign(
        {},
        ...Object.entries(modalContent).map(([key, item]) => ({
          [key]: keepDefaultValues
            ? item.value
            : ["select-multiple", "image"].includes(item.type ?? "text")
            ? []
            : ["date", "time", "datetime"].includes(item.type ?? "text")
            ? null
            : "",
        }))
      );
      reset(formObj);
    }
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  useEffect(() => {
    if (modalFormResetKeys && modalFormResetKeys.length > 0) {
      if (modalContent) {
        const formObj = Object.assign(
          {},
          ...Object.entries(modalContent).map(([key, item]) => {
            if (modalFormResetKeys && modalFormResetKeys.includes(key))
              return { [key]: item.value };
            return { [key]: getValues(`${key}`) };
          })
        );
        reset(formObj, { keepErrors: true });
      }
    } else clearData(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalContent, modalFormResetKeys]);
  useEffect(() => {
    setSnackOpen(
      modalFormError && Object.keys(modalFormError).length > 0 ? true : false
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalFormError]);

  const handleModalClose = () => {
    clearErrors();
    clearData();
    handleClose();
  };
  return (
    <Dialog
      open={open}
      onClose={handleModalClose}
      aria-labelledby="form-dialog-title"
      scroll="paper"
      maxWidth={modalWidth}
      disableEscapeKeyDown
      disableBackdropClick
    >
      <DialogTitle className={classes.ModalTitle}>{title}</DialogTitle>
      <DialogContent dividers>
        {header && (
          <DialogContentText variant="subtitle2">{header}</DialogContentText>
        )}
        {isForm === true ? (
          <Grid container spacing={2}>
            {modalContent &&
              Object.entries(modalContent).map(([key, item]) =>
                item.type === "table" ? (
                  <Grid key={key} item xs={12} md={item.col}>
                    <MaterialTable
                      title={item.label}
                      icons={tableIcons}
                      columns={item.columns}
                      data={item.data}
                      editable={item.editable}
                      detailPanel={item.detailPanel}
                      options={{
                        ...stylingOptions,
                        pageSize: 3,
                        pageSizeOptions: [3, 5, 10, 20],
                        headerStyle: {
                          backgroundColor: "#6e6e6e",
                          color: "#FFF",
                        },
                        search: true,
                        padding: "dense",
                        ...item.tableOptions,
                      }}
                    />
                  </Grid>
                ) : (
                  <Grid
                    container
                    key={key}
                    item
                    xs={12}
                    md={item.col}
                    justify={item.justify ?? "flex-start"}
                  >
                    {
                      <Switch on={item.type ?? "text"}>
                        <Controller
                          case="image"
                          name={`${key}`}
                          control={control}
                          rules={item.validator}
                          defaultValue={item.value}
                          render={({ field }) => (
                            <>
                              <DropzoneArea
                                {...field}
                                {...item.dropzoneOptions}
                                initialFiles={item.value}
                                disabled={
                                  (item.disabled && true) ||
                                  (isReadOnly ?? false)
                                }
                              />
                              {errors[`${key}`] && (
                                <span className={classes.invalid}>
                                  {errors[`${key}`].message}
                                </span>
                              )}
                            </>
                          )}
                        />
                        <Controller
                          case="select"
                          control={control}
                          rules={item.validator}
                          name={`${key}`}
                          defaultValue={item.value}
                          render={({ field }) => (
                            <>
                              <TextField
                                {...field}
                                fullWidth
                                size={item.size}
                                variant={item.variant}
                                label={item.label}
                                select
                                SelectProps={item.selectProps}
                                disabled={isReadOnly}
                                onChange={(e) => {
                                  field.onChange(e);
                                  item.onSelectionChange &&
                                    item.onSelectionChange(e);
                                }}
                                error={!!errors[`${key}`]}
                              >
                                {item.menuItems.map((item) => (
                                  <MenuItem
                                    key={`${item.val}_${item.text}`}
                                    value={item.val}
                                    
                                  >
                                    <Grid container alignItems="center" spacing={1} wrap='nowrap'>
                                      {item.startAddornment 
                                      ? <Grid item>
                                        {item.startAddornment}
                                      </Grid>
                                      :null }
                                      <Grid item>
                                      {item.text}
                                      </Grid>
                                    </Grid>
                                    
                                    
                                  </MenuItem>
                                ))}
                              </TextField>
                              {errors[`${key}`] && (
                                <span className={classes.invalid}>
                                  {errors[`${key}`].message}
                                </span>
                              )}
                            </>
                          )}
                        />
                        <Controller
                          case="select-multiple"
                          control={control}
                          rules={item.validator}
                          name={`${key}`}
                          defaultValue={item.value}
                          render={({ field }) => (
                            <>
                              <TextField
                                {...field}
                                fullWidth
                                size={item.size}
                                variant={item.variant}
                                label={item.label}
                                select
                                SelectProps={{
                                  multiple: true,
                                  renderValue: (selected) => (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      {selected.map((value) => (
                                        <Chip
                                          style={{ margin: 2 }}
                                          variant="outlined"
                                          key={value}
                                          label={
                                            item.menuItems.find(
                                              (item) => item.id === value
                                            )?.name
                                          }
                                        />
                                      ))}
                                    </div>
                                  ),
                                }}
                                disabled={isReadOnly}
                                onChange={(e) => {
                                  field.onChange(e);
                                  item.onSelectionChange &&
                                    item.onSelectionChange(e);
                                }}
                                error={!!errors[`${key}`]}
                              >
                                {item.menuItems.map((mitem) => (
                                  <MenuItem key={mitem.id} value={mitem.id}>
                                    <Checkbox
                                      color="primary"
                                      checked={
                                        field.value.indexOf(mitem.id) > -1
                                      }
                                    />
                                    <ListItemText primary={mitem.name} />
                                  </MenuItem>
                                ))}
                              </TextField>
                              {errors[`${key}`] && (
                                <span className={classes.invalid}>
                                  {errors[`${key}`].message}
                                </span>
                              )}
                            </>
                          )}
                        />
                        <Controller
                          case="text"
                          name={`${key}`}
                          control={control}
                          rules={item.validator}
                          defaultValue={item.value}
                          render={({ field }) => (
                            <>
                              <TextField
                                {...field}
                                fullWidth
                                size={item.size}
                                variant={item.variant}
                                label={item.label}
                                type={item.type ? item.type : "text"}
                                disabled={
                                  (item.disabled && true) ||
                                  (isReadOnly ?? false)
                                }
                                error={!!errors[`${key}`]}
                              />
                              {errors[`${key}`] && (
                                <span className={classes.invalid}>
                                  {errors[`${key}`].message}
                                </span>
                              )}
                            </>
                          )}
                        />
                        <div>{}</div>
                        <Controller
                          case="password"
                          name={`${key}`}
                          control={control}
                          rules={
                            item.match
                              ? {
                                  validate: (value) =>
                                    getValues(`${item.match.field}`) === value,
                                }
                              : item.validator
                          }
                          defaultValue={item.value}
                          render={({ field }) => (
                            <>
                              <TextField
                                {...field}
                                fullWidth
                                size={item.size}
                                variant={item.variant}
                                label={item.label}
                                type={item.showPassword ? "text" : "password"}
                                disabled={
                                  (item.disabled && true) ||
                                  (isReadOnly ?? false)
                                }
                                error={!!errors[`${key}`]}
                                onChange={(e) => {
                                  field.onChange(e);
                                  item.onTextChange && item.onTextChange(e);
                                }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        aria-label="toggle password visibility"
                                        className={classes.no_pading}
                                        onMouseDown={handleMouseDownPassword}
                                        onClick={() =>
                                          item.setShowPassword(
                                            getValues(`${key}`)
                                          )
                                        }
                                      >
                                        <Icon fontSize="small">{`visibility${
                                          !!!item.showPassword && "_off"
                                        }`}</Icon>
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              ></TextField>
                              {errors[`${key}`] && (
                                <span className={classes.invalid}>
                                  {errors[`${key}`].type === "validate"
                                    ? `${item.match.errorMsg}`
                                    : errors[`${key}`].message}
                                </span>
                              )}
                            </>
                          )}
                        />
                        <Controller
                          case="switch"
                          name={`${key}`}
                          control={control}
                          rules={item.validator}
                          defaultValue={item.value}
                          render={({ field }) => (
                            <FormControlLabel
                              control={
                                <MUSwitch
                                  {...field}
                                  checked={!!field.value}
                                  color="primary"
                                  onChange={(e) => {
                                    field.onChange(e);
                                    item.onSwitchChange &&
                                      item.onSwitchChange(e);
                                  }}
                                />
                              }
                              label={item.label}
                              labelPlacement="end"
                            />
                          )}
                        />
                        <Controller
                          case="slider"
                          name={`${key}`}
                          control={control}
                          rules={item.validator}
                          defaultValue={item.value}
                          render={({ field }) => {
                            const sMin = item.min ?? 0;
                            const sMax = item.max ?? 100;
                            const pos = item.invert
                              ? sMax - (field.value ?? sMin)
                              : field.value ?? sMin;
                            return (
                              <div style={{ width: "100%", paddingLeft: 8, paddingRight: 8 }}>
                                {item.label && (
                                  <Typography variant="caption" color="textSecondary">
                                    {item.label}
                                  </Typography>
                                )}
                                <ThickSlider
                                  value={pos}
                                  min={sMin}
                                  max={sMax}
                                  step={item.step ?? null}
                                  marks={item.marks ?? true}
                                  valueLabelDisplay={item.valueLabelDisplay ?? "off"}
                                  disabled={(item.disabled && true) || (isReadOnly ?? false)}
                                  color="primary"
                                  onChange={(e, val) => {
                                    const stored = item.invert ? sMax - val : val;
                                    field.onChange(stored);
                                    item.onSliderChange && item.onSliderChange(stored);
                                  }}
                                />
                              </div>
                            );
                          }}
                        />
                        <Controller
                          case="datetime"
                          name={`${key}`}
                          control={control}
                          rules={item.validator}
                          defaultValue={item.value}
                          render={({ field }) => (
                            <>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DateTimePicker
                                  {...field}
                                  fullWidth
                                  size={item.size}
                                  inputVariant={item.variant}
                                  label={item.label}
                                  clearable
                                  format="MM/dd/yyyy hh:mm a"
                                  disabled={
                                    (item.disabled && true) ||
                                    (isReadOnly ?? false)
                                  }
                                  error={!!errors[`${key}`]}
                                  minDate={item.minDate}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton size="small">
                                          <CalendarToday fontSize="small" />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    item.onChange && item.onChange(key, e);
                                  }}
                                />
                              </MuiPickersUtilsProvider>
                              {errors[`${key}`] && (
                                <span className={classes.invalid}>
                                  {errors[`${key}`].message}
                                </span>
                              )}
                            </>
                          )}
                        />
                        <Controller
                          case="date"
                          name={`${key}`}
                          control={control}
                          rules={item.validator}
                          defaultValue={item.value}
                          render={({ field }) => (
                            <>
                              <MuiPickersUtilsProvider
                                case="date"
                                utils={DateFnsUtils}
                              >
                                <DatePicker
                                  {...field}
                                  fullWidth
                                  size={item.size}
                                  inputVariant={item.variant}
                                  label={item.label}
                                  clearable
                                  format="MM/dd/yyyy"
                                  disabled={
                                    (item.disabled && true) ||
                                    (isReadOnly ?? false)
                                  }
                                  error={!!errors[`${key}`]}
                                  minDate={item.minDate}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton size="small">
                                          <CalendarToday fontSize="small" />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    item.onChange && item.onChange(key, e);
                                  }}
                                />
                              </MuiPickersUtilsProvider>
                              {errors[`${key}`] && (
                                <span className={classes.invalid}>
                                  {errors[`${key}`].message}
                                </span>
                              )}
                            </>
                          )}
                        />
                        <Controller
                          case="checkbox"
                          name={`${key}`}
                          control={control}
                          rules={item.validator}
                          defaultValue={item.value}
                          render={({ field }) => (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  {...field}
                                  color="primary"
                                  disabled={isReadOnly}
                                />
                              }
                              label={item.label}
                              labelPlacement="end"
                            />
                          )}
                        />
                      </Switch>
                    }
                  </Grid>
                )
              )}
          </Grid>
        ) : (
          <>{modalContent}</>
        )}
        {modalFormError && Object.keys(modalFormError).length > 0 && (
          <Snackbar
            open={snak_open}
            autoHideDuration={6000}
            onClose={() => setSnackOpen(false)}
            TransitionComponent={(props) => (
              <Slide {...props} direction="right" />
            )}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          >
            <Alert severity="error" variant="filled">
              {modalFormError.message ?? modalFormError.details}
            </Alert>
          </Snackbar>
        )}
      </DialogContent>
      <DialogActions>
        {isForm === true &&
          modalActions &&
          modalActions.map((item) => (
            <Fragment key={item.label}>
              {item.isSubmit === true ? (
                <Button
                  onClick={handleSubmit(item.action)}
                  startIcon={
                    modalTaskRunning === true ? (
                      <CircularProgress size={14} color="inherit" />
                    ) : (
                      <item.icon />
                    )
                  }
                  color="primary"
                  variant="contained"
                  disableElevation
                  disabled={modalTaskRunning}
                >
                  {item.label}
                </Button>
              ) : (
                <Button
                  onClick={item.action}
                  startIcon={<item.icon />}
                  color="primary"
                  variant="contained"
                  disableElevation
                >
                  {item.label}
                </Button>
              )}
            </Fragment>
          ))}
        <Button
          onClick={handleModalClose}
          startIcon={<Clear />}
          color="secondary"
          variant="outlined"
          disabled={modalTaskRunning}
        >
          {(isReadOnly === true && "Close") || "Cancel"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
const ToolBar = ({ title, icons, onAction, canCreate }) => {
  const classes = useStyles();
  return (
    <>
      <Toolbar>
        <Grid item xs className={classes.title}>
          <Typography variant="h6">{title}</Typography>
        </Grid>
        {canCreate === true && (
          <Tooltip title="Add">
            <IconButton onClick={onAction} edge="end">
              <icons.Add />
            </IconButton>
          </Tooltip>
        )}
      </Toolbar>
    </>
  );
};
const TabPanel = (props) => {
  const { value, index, type, children, ...other } = props;
  const classes = useStyles();
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
export { ToolBar, ModalDialog, TabPanel };
